import React from "react";

import { SearchX, Users } from "lucide-react";

import Button from "../../../Components/Button";

type TeamViewsEmptyStateProps = {
  searchQuery?: string;
  scope?: "people" | "accounts";
  title?: string;
  description?: string;
  onClearSearch?: () => void;
};

const SEARCH_DESCRIPTION =
  "Nothing matched. Try another name, role, or account.";

/** Centered SaaS empty state for Team Views search / filter misses. */
const TeamViewsEmptyState: React.FC<TeamViewsEmptyStateProps> = ({
  searchQuery = "",
  scope = "people",
  title,
  description,
  onClearSearch,
}) => {
  const isSearchMiss = Boolean(searchQuery.trim());
  const resolvedTitle =
    title ||
    (isSearchMiss
      ? scope === "accounts"
        ? "No accounts found"
        : "No Person found"
      : scope === "accounts"
        ? "No accounts to show"
        : "No people in the roster");
  const resolvedDescription =
    description ||
    (isSearchMiss
      ? SEARCH_DESCRIPTION
      : scope === "accounts"
        ? "Try adjusting filters or turn off Show my team."
        : "Try adjusting filters or turn off Show my team.");

  const Icon = isSearchMiss ? SearchX : Users;

  return (
    <div className="tv-empty-state" role="status" aria-live="polite">
      <div className="tv-empty-state-card">
        <div className="tv-empty-state-visual" aria-hidden>
          <span className="tv-empty-state-ripple tv-empty-state-ripple--1" />
          <span className="tv-empty-state-ripple tv-empty-state-ripple--2" />
          <span className="tv-empty-state-ripple tv-empty-state-ripple--3" />
          <span className="tv-empty-state-icon-wrap">
            <Icon className="tv-empty-state-icon" strokeWidth={1.75} />
          </span>
        </div>
        <h3 className="tv-empty-state-title">{resolvedTitle}</h3>
        <p className="tv-empty-state-desc">{resolvedDescription}</p>
        {isSearchMiss && onClearSearch ? (
          <Button
            variant="outline-primary"
            className="tv-empty-state-cta"
            onClick={onClearSearch}
          >
            Clear search
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default TeamViewsEmptyState;
